import React, { Component } from "react";
import PropTypes from "prop-types";
import Subscription from "./Subscription.js";
import { blogPosts } from "../shared/_constants.js";
import "./BecomeMember.css";
import logo from "../outro-logo.svg";
import pittDance from "../pitt-dance.gif";

class BecomeMember extends Component {
  constructor() {
    super();
    this.state = {
      showWhyText: false,
    };
  }

  componentDidMount() {
    window.analytics.track("Opens Become Member Popup");
  }

  componentWillReceiveProps(newProps) {
    if (
      !this.props.payment.activeSubscription &&
      newProps.payment.activeSubscription
    ) {
      setTimeout(() => {
        this.props.openCloseFreeModal(false);
      }, 2900); //3200 is exact length of pitt gif, - 300 for the default-duration

      window.analytics.track("Becomes a Paid Member");
    }
  }

  toggleWhyText = () => {
    this.setState({
      showWhyText: !this.state.showWhyText,
    });
  };

  render() {
    if (!this.props.payment) {
      return false;
    }

    const promptForUpgrade = (
      <div className="upgrade-container">
        <Subscription payment={this.props.payment} user={this.props.user} />
        <div className="why-link" onClick={this.toggleWhyText}>
          Why isn't this free?
        </div>
        <div className={`why-text-container ${this.state.showWhyText}`}>
          <div className="why-text">
            <p>
              Because your support is important! Outro is a passion project that
              we dedicated our free time to.
            </p>
            <div className="meet-the-makers">
              <a
                href={blogPosts.introToOutro}
                target="_blank"
                onClick={() => {
                  window.analytics.track("Opens Blog Post", {
                    post: "intro to outro",
                  });
                }}
              >
                Read Our Story
              </a>
            </div>
            <p>
              If your team can’t afford to upgrade, that’s ok. Contact us at
              hello@outro.co and we'll see what we can do.
            </p>
          </div>
        </div>
      </div>
    );

    const youRock = (
      <div className="we-did-it">
        <p>We did it!</p>
        <img src={pittDance} alt="pitt-dance" loop="true" />
      </div>
    );

    return (
      <div className="become-member-container">
        <div className="logo">
          <img src={logo} alt="outro-logo" />
        </div>
        <div className="modal-title">Become an Outro member for $10/month</div>
        <div className="description">
          Host unlimited Outros. All team members are free. Cancel anytime.
        </div>

        {this.props.payment.activeSubscription ? youRock : promptForUpgrade}
      </div>
    );
  }
}

BecomeMember.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    uid: PropTypes.string.isRequired,
    creationTime: PropTypes.string.isRequired,
    lastSignInTime: PropTypes.string.isRequired,
    photoURL: PropTypes.string,
  }),
  payment: PropTypes.shape({
    activeSubscription: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    stripeCustomerID: PropTypes.string.isRequired,
  }),
  openCloseFreeModal: PropTypes.func.isRequired,
};

export default BecomeMember;



// WEBPACK FOOTER //
// ./src/components/BecomeMember.js